'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./BoardLock.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoardLock = function BoardLock(_ref) {
    var isLocked = _ref.isLocked;

    if (!isLocked) return null;

    return _react2.default.createElement(
        'div',
        { className: 'BoardLock' },
        _react2.default.createElement(_Icon2.default, { name: 'board-lock' })
    );
};

BoardLock.propTypes = {
    isLocked: _propTypes2.default.bool
};

exports.default = (0, _recompose.pure)(BoardLock);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardIcon/BoardLock.js
// module id = 1953
// module chunks = 0